<script>
import { taiwanCitys, districtsFilter } from '@utils/filter-value-to-text'

export default {
  props: {
    itemIndex: {
      type: Number,
      default: 0,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    citys: {
      type: Array,
      required: true,
    },
    showRemove: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      taiwanCitys,
      openCloseCardStatus: true,
      submitData: Object.assign(
        {
          city: '',
          region: [],
        },
        this.defaultValue
      ),
    }
  },
  computed: {
    districts() {
      return districtsFilter(this.defaultValue.city)
    },
    regionStr(){
      return this.defaultValue.district.join(', ')
    }
  },
  methods: {
    onSelectCity(type) {
      this.defaultValue.district = []
    },
    onRemove() {
      this.$emit('remove', this.itemIndex)
    },
    /**
     * @description 開啟關閉 card
     */
    openCloseCard(){
      this.openCloseCardStatus = !this.openCloseCardStatus
    }
  },
}
</script>

<template>
  <el-card :class="[$style.cardMainClass]">
    <div :class="$style.anglePart">
      <el-button class="is-no-style" 
        :class="openCloseCardStatus ? '' : $style.elButtonRotate" 
        @click="openCloseCard">
        <BaseIcon name="angle-down"/>
      </el-button>
      <p :class="$style.cityPosition">{{ defaultValue.city }}</p>
      <p :class="$style.regionPosition">{{ regionStr }}</p>
    </div>
    <div :class="[$style.cardBody]" v-if="openCloseCardStatus">
      <el-form-item :prop="'addressRestrictions.' + itemIndex + '.city'" :rules="{ required: true, message: '請選擇縣市' }" label="縣市">
        <el-select v-model="defaultValue.city" placeholder="請選擇縣市" @change="onSelectCity" class="is-border is-rounded">
          <el-option v-for="(city, index) in citys" :key="`member-city-${index}`" :label="city.name" :value="city.name"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :prop="'addressRestrictions.' + itemIndex + '.district'" :rules="{ required: true, message: '請選擇區域' }" label="區域（可複選）" style="margin-bottom: 20px;">
        <el-select v-model="defaultValue.district" placeholder="請選擇鄉鎮市區" multiple class="is-border tags-round">
          <el-option v-for="(district, index) in districts" :key="`member-district-${index}`" :label="district.name" :value="district.name"> </el-option>
        </el-select>
      </el-form-item>
    </div>
  </el-card>
</template>

<style lang="scss" module>
.cardMainClass {
  background-color: white;
  margin-bottom: 20px;
  :global {
    .el-card__body {
      padding: 0px;
    }
    .el-form-item {
      margin: 0px;
    }
  }
}

.anglePart {
  background-color: $color-line;
  display: flex;
  align-items: center;
  padding: 19px 21px;
  > p.cityPosition {
    padding-left: 13px;
    width: 176px;
  }
  > p.regionPosition {
    flex-grow: 1;
    overflow-y: auto;
  }
  > .elButtonRotate {
    transform: rotate(180deg);
  }
  > p {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}


.cardBody {
  padding: 24px 20px;
  > .el-form-item {
    margin: 0px;
  }
}
</style>